import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

export const SCROLL_ROOT_ATTR = 'data-scroll-root'

const positions = new Map<string, number>()

const innerPositions = new Map<string, number>()

function scrollRoot(): HTMLElement | null {
  return document.querySelector<HTMLElement>(`[${SCROLL_ROOT_ATTR}]`)
}

const RESTORE_TIMEOUT_MS = 1000

export function ScrollManager() {
  const location = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    const key = location.key
    const target = navigationType === 'POP' ? (positions.get(key) ?? 0) : 0

    const innerTarget = navigationType === 'POP' ? (innerPositions.get(key) ?? 0) : 0

    let frame = 0
    const deadline = performance.now() + RESTORE_TIMEOUT_MS
    const settle = () => {
      window.scrollTo(0, target)
      const root = scrollRoot()
      if (root !== null) root.scrollTop = innerTarget

      const reachable = document.documentElement.scrollHeight - window.innerHeight
      const innerReachable = root === null ? 0 : root.scrollHeight - root.clientHeight
      const winPending = target > 0 && reachable < target
      const innerPending = innerTarget > 0 && innerReachable < innerTarget
      if ((winPending || innerPending) && performance.now() < deadline) {
        frame = requestAnimationFrame(settle)
      }
    }
    settle()

    return () => {
      cancelAnimationFrame(frame)
      positions.set(key, window.scrollY)
      const root = scrollRoot()
      if (root !== null) innerPositions.set(key, root.scrollTop)
    }
  }, [location.key, navigationType])

  return null
}
